package org.lennycodes.hldi.backend.db_service

import com.varabyte.kobweb.compose.dom.ref
import kotlinx.coroutines.await
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.deleteDoc
import org.lennycodes.hldi.backend.deleteObject
import org.lennycodes.hldi.backend.doc
import org.lennycodes.hldi.backend.ref
import org.lennycodes.hldi.data.GalleryImage

suspend fun deleteGalleryImage(image: GalleryImage) {
    // Delete Firestore document
    deleteDoc(
        doc(
            collection(FirebaseService.db, "gallery"),
            image.id
        )
    ).await()

    // Delete image from Storage using the actual stored path
    if (image.storagePath.isNotBlank()) {
        try {
            val imageRef = ref(FirebaseService.storage, image.storagePath)
            deleteObject(imageRef).await()
        } catch (e: Throwable) {
            console.error("Storage delete failed: ${e.message}")
        }
    }
}